<template>
<div>
    <b-container class="px-0">

        <b-row class="justify-content-md-center">
            <b-col cols="12" class="mb-4">

                <b-card class="shadow p-0 my-3 mb-4 rounded bg-transparent">
                    <template v-if="colectii">
                        <h2>{{titlu}}</h2>
                    </template>
                    
                    <div v-if="images.length > 1">
                            <div v-if="loading">
                                <div class="text-center">
                                    <b-spinner variant="primary" label="Se incarca..."></b-spinner>
                                </div>
                            </div>
                                    <!--<b-img v-gallery:galerie :src="i['o:original_url']" fluid class="mb-1">

                                </b-img>-->
                            <div class="images" v-viewer="{movable: false}" >
                              <b-img  v-for="im in images" :key="im" :src="im" fluid class="mb-1"></b-img>
                             </div>

                         
                        </div>

                    
                    <div v-for="i in sub" :key="i['o:id']">
                        <div v-if="i['o:media_type'] == null">
                            <b-embed type="iframe" :src="i['o:source'] | gen_embed" allowfullscreen class="my-1"></b-embed>
                        </div>
                        <div class="justify-content-center my-2 text-center" v-if="i['o:media_type'] == 'application/pdf'">
                            <b-img :src="i['o:thumbnail_urls']['large']" fluid></b-img>
                            <div class="d-flex justify-content-center py-4">
                                <b-button :src="i['o:original_url']" @click="onClick(i['o:original_url'],c['o:id'])">
                                    <b-icon icon="cloud-download" aria-hidden="true" class="pr-2"></b-icon>Descarcă
                                </b-button>
                                <b-button @click="showPdffun(i['o:original_url'])" class="ml-1">
                                    <b-icon icon="book" aria-hidden="true" class="pr-2"></b-icon> Afișează
                                </b-button>                              
                            </div>
                        <div class="text-center autor_articol">
                        <b-card-text v-if="i['o:size'] > 1">Mărime fișier: {{i['o:size'] | prettyBytes}}</b-card-text>
                        </div>


                        </div>
                        <div v-if="i['o:media_type'] == 'audio/mpeg'">
                            <div v-for="col in sub" :key="col['o:id']">
                                <audio controls>
                                    <source :src="i['o:original_url']" type="audio/mpeg">
                                    Browser-ul tău nu redă acest format audio.
                                </audio>
                            </div>
                        </div>


                        <!-- </div> -->


                    </div>

                    <div  v-for="c in colectii" :key="c['o:id']" >
                        <div v-if="colectii">
                            <span class="autor_articol">Titlu:</span> {{titlu}}
                        </div>
                        <div v-if="c['dcterms:description']">
                            <span class="autor_articol">Descriere:</span> {{c['dcterms:description']['0']['@value']}}
                        </div>
                        <div v-if="c['dcterms:creator']">
                           <span class="autor_articol">Autor:</span> {{c['dcterms:creator']['0']['@value'] || c['dcterms:creator']['0']['display_title']}}
                        </div>
                 

                        <div v-if="c['mo:composer']">
                           <span class="autor_articol">Compozitor:</span>   {{c['mo:composer']['0']['display_title'] ||  c['mo:composer']['0']['@value']}} <br/>
                            <b-img v-if="c['mo:composer']['0']['thumbnail_url']" :src="c['mo:composer']['0']['thumbnail_url']" fluid></b-img>
                        </div>
                        <div v-if="c['mo:performer']">
                            <span class="autor_articol">Interpret:  </span> {{c['mo:performer']['0']['@value']}}
                        </div>

                        <div v-if="c['mo:conductor']">
                            <span class="autor_articol">Dirijor:</span>   {{c['mo:conductor']['0']['@value']}}
                        </div>
                        <div v-if="c['dcterms:publisher']">
                            <span class="autor_articol">Editură:</span>   {{c['dcterms:publisher']['0']['display_title']}}<br/>
                             <b-img v-if="c['dcterms:publisher']['0']['thumbnail_url']" :src="c['dcterms:publisher']['0']['thumbnail_url']" fluid></b-img>
                            <!-- {{c['dcterms:publisher']['0']['@id']}} -->
                        </div>
                        <div v-if="c['dcterms:date']">
                           <span class="autor_articol">Dată:</span>   {{c['dcterms:date']['0']['@value']}} 
                        </div> 
                    </div>


                    <vuepdflook @closepdf="closepdf" v-model="isshowpdf" :pdfurl="pdfurls" @pdferr="pdferr" :maxscale='4' :minscale='0.1' :scale='0.6'></vuepdflook>
                </b-card>
            </b-col>
        </b-row>

    </b-container>
</div>
</template>

<script>

import Vue from 'vue';
import vuepdflook from 'vuepdflook';
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)
Vue.use(require('vue-filter-pretty-bytes'))

//import Viewer from 'v-viewer';
//Vue.use(Viewer);
import gallery from 'img-vuer'
Vue.use(require('vue-moment'));
Vue.use(gallery, {
    swipeThreshold: 150, // default 100
    isIndexShow: true, // show image index, default true
    useCloseButton: true, // trigger gallery close with close button, default true
    preload: true, // preload images in the same group, default true
})

Vue.filter('gen_embed', function (value) {
    if (value) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = value.match(regExp);
        return (match && match[7].length == 11) ? 'https://www.youtube.com/embed/' + match[7] : false;
    }
});


Vue.filter('getSize', function (value) {
    if (value) {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
   if (value == 0) return '0 Byte';
   var i = parseInt(Math.floor(Math.log(value) / Math.log(1024)));
   return Math.round(value / Math.pow(1024, i), 2) + ' ' + sizes[i];
    }
});


export default {
    data() {
        return {
            pageTitle: 'Biblioteca Digitală',
            colectii: [],
            pdfurls: '',
            isshowpdf: false,
            loading: 'true',
            sub: [],
            images: [],
            titlu: '',
            editura : '',
        }
    },
    methods: {
        getSubColectii() {
            const data = this.colectii;
            const arr = data['0'].id_site.split(',');
            for (let index = 0; index < arr.length; index++) {
                const element = arr[index];
                fetch('https://digital.bibliotecaarad.ro/api/item_sets/' + element)
                    .then(response => response.json())
                    .then(data => this.sub.push(data));
            }
        },
        changecolectii() {
            setTimeout(() => {
                this.colectii = false;
            }, 0);
        },
        show() {
            const viewer = this.$el.querySelector('.images').$viewer
            viewer.show()
        },
        closepdf() {
            this.isshowpdf = false
        },
        pdferr(errurl) {
            console.log(errurl);
        },
        showPdffun(value) {
            this.pdfurls = value;
            this.isshowpdf = true;
        },
        getColectii() {
            fetch('https://digital.bibliotecaarad.ro/api/items?id=' + this.$route.params.id)
                .then(response => response.json())
                .then(data => {
                    this.colectii.push(data);
                    data.length > 1 ? this.getMedia(data['o:media']) : this.getMedia(data[0]['o:media']);
                     data.length > 1 ? this.titlu = data['dcterms:title']['0']['@value'] : this.titlu = data[0]['dcterms:title']['0']['@value'];
                });

        },
        getMedia(media) {
            for (let index = 0; index < media.length; index++) {
                const element = media[index];
                fetch('https://digital.bibliotecaarad.ro/api/media/' + element['o:id'])
                    .then(response => response.json())
                    .then(data => {                       
                        var img = data['o:original_url'];
                        //console.log(img);
                        this.images.push(img);
                        this.sub.push(data);
                    });

            }
        },
        onClick(value, id) {
            fetch(value)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.blob();
                })
                .then(myBlob => {
                    var fileURL = window.URL.createObjectURL(new Blob([myBlob]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', id + '.pdf');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                })
                .catch(error => {
                    console.error('There has been a problem with your fetch operation:', error);
                });

        }
    },
    created() {
        this.getColectii();
        setTimeout(() => {
            this.loading = false;
        }, 6000);
    },
    components: {
        vuepdflook
    }
}
</script>

<style scoped>
[v-cloak] {
    display: none;
}

.autor_articol {
    font-weight: 600;
    font-size: 1.1rem;
}

</style>